import React, { createContext, useContext, useState } from 'react';
import { nl, t as translate } from '../locales/nl';

const LocaleContext = createContext();

export const useLocale = () => {
  const context = useContext(LocaleContext);
  if (!context) {
    throw new Error('useLocale must be used within a LocaleProvider');
  }
  return context;
};

export const LocaleProvider = ({ children }) => {
  // For now, Dutch is the only language, but structure allows for future expansion
  const [locale, setLocale] = useState('nl');
  
  const translations = {
    nl: nl
  };

  const t = (key, params = {}) => {
    return translate(key, params);
  };

  const value = {
    locale,
    setLocale,
    t,
    translations
  };

  return (
    <LocaleContext.Provider value={value}>
      {children}
    </LocaleContext.Provider>
  );
};

export default LocaleContext;

